// Vínculo contratual — SÓ EXIBIÇÃO (selo). Não muda perfil/permissões.
// Fonte única de rótulo/cor/opções pra não divergir entre telas.
export const VINCULO_LABEL: Record<string, string> = {
  clt: "CLT",
  pj: "PJ",
  terceirizado: "Terceirizado",
};

export const VINCULO_BADGE: Record<string, string> = {
  clt: "bg-slate-100 text-slate-600 dark:bg-slate-700 dark:text-slate-300",
  pj: "bg-orange-100 text-orange-700 dark:bg-orange-900/40 dark:text-orange-300",
  terceirizado: "bg-purple-100 text-purple-700 dark:bg-purple-900/40 dark:text-purple-300",
};

// Opções pro <select> do cadastro de usuário ("" = sem selo).
export const VINCULO_OPCOES: Array<{ value: string; label: string }> = [
  { value: "", label: "— (sem selo)" },
  { value: "clt", label: "CLT" },
  { value: "pj", label: "PJ" },
  { value: "terceirizado", label: "Terceirizado" },
];
